import "./OurLegacy.module.css";
import Header from "@/reusable_sections/Header";
import TheYellowBlackEra from "./sections/TheYellowBlackEra";
import TheArchitectsOfSpeech from "./sections/TheArchitectsOfSpeech";
import VictoryMetrics from "./sections/VictoryMetrics";
import Footer from "@/reusable_sections/Footer";
export default function OurLegacyPage() {
  return <div>
      <Header />
      <TheYellowBlackEra />
      <TheArchitectsOfSpeech />
      <VictoryMetrics />
      <Footer />
    </div>;
}